var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "switcher" }, [
    _vm.labelBefore
      ? _c("div", {
          staticClass: "switcher__label switcher__label--before",
          domProps: { textContent: _vm._s(_vm.labelBefore) },
          on: { click: _vm.toggle }
        })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "switcher__handler",
        class: { "switcher__handler--active": _vm.value },
        on: { click: _vm.toggle }
      },
      [_c("div", { staticClass: "switch" })]
    ),
    _vm._v(" "),
    _vm.labelAfter
      ? _c("div", {
          staticClass: "switcher__label switcher__label--after",
          domProps: { textContent: _vm._s(_vm.labelAfter) },
          on: { click: _vm.toggle }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }